// extracted by mini-css-extract-plugin
export default {"link":"SocialMediaLink_link__if9Uz"};